import { formatBrlMoney } from '@/lib/functions';
import { plural } from '@/lib/plural';
import useProductStore from '@/stores/productStore';

import { optionsBilling } from '../ProductPrice/Subscription/BillingCycle';

const ReviewModeSubscription = () => {
  const product = useProductStore(d => d);

  const getSelectedBillingCycle = () => {
    return optionsBilling.find(option => option.value === product.payment.billingCycle)?.label.toLowerCase() || '';
  };

  return (
    <div className='flex flex-col'>
      <div>Assinatura {getSelectedBillingCycle()}</div>
      <div>{formatBrlMoney(product.payment.price!)} por ciclo.</div>
      <div>
        {product.payment.recurrenceCount === 0
          ? 'Nunca termina.'
          : `Termina após ${plural(product.payment.recurrenceCount, 'cobrança')}`}
      </div>
      <div>
        Tolerância de atraso de {product.payment.maximumLatePayments}{' '}
        {plural(product.payment.maximumLatePayments, 'cobrança')}
      </div>
      <div>
        {product.payment.activationFeeEnabled &&
          `Taxa de adesão de ${formatBrlMoney(product.payment.activationFeeValue!)}`}
      </div>
      <div>
        {product.payment.trialEnabled &&
          `Período experimental de ${product.payment.trialDays} ${plural(product.payment.trialDays, 'dia')}`}
      </div>
    </div>
  );
};

export default ReviewModeSubscription;
